export const NoQuotationIcon = () => {
	return (
		<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M23.7823 5.10135V9.92241C23.7808 12.2754 25.6861 14.184 28.0391 14.1905H32.604M25.4413 6.05085C24.7976 5.3795 23.9073 5.00005 22.9765 5.00005H13.5582C10.1576 4.98706 7.3717 7.6968 7.29062 11.0957V28.6075C7.2144 32.0617 9.95332 34.9222 13.4074 34.9983C13.4576 35 26.6171 35 26.6171 35C30.0403 34.8605 32.737 32.0325 32.7128 28.6075V14.9989C32.7128 14.1168 32.3706 13.2687 31.7608 12.633L25.4413 6.05085Z"
				stroke="black"
				strokeWidth="1.875"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M21.1867 18.0469H17.191C16.0023 18.0469 15.0391 19.0102 15.0391 20.1989C15.0391 21.3874 16.0023 22.3507 17.191 22.3507H19.6493C20.838 22.3507 21.8012 23.3139 21.8012 24.5025C21.8012 25.6912 20.838 26.6545 19.6493 26.6545H15.6536"
				stroke="black"
				strokeWidth="1.875"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M18.4219 26.6594V28.4657M18.4219 16.2344V18.057"
				stroke="black"
				strokeWidth="1.875"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
